import React from "react";

const ViewButton = ({ onClickFunction }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={() => {
        onClickFunction();
      }}
      aria-hidden="true"
      role="img"
      class="iconify iconify--solar minimal__iconify__root css-1bkxjvr"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M9.75 12a2.25 2.25 0 1 1 4.5 0a2.25 2.25 0 0 1-4.5 0"
      ></path>
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M2 12c0 1.64.425 2.191 1.275 3.296C4.972 17.5 7.818 20 12 20s7.028-2.5 8.725-4.704C21.575 14.192 22 13.639 22 12c0-1.64-.425-2.191-1.275-3.296C19.028 6.5 16.182 4 12 4S4.972 6.5 3.275 8.704C2.425 9.81 2 10.361 2 12m10-3.75a3.75 3.75 0 1 0 0 7.5a3.75 3.75 0 0 0 0-7.5"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};

export default ViewButton;
